<template>
  <tela-component title="Relatório Vendas Concretizadas">
    <v-progress-linear
      indeterminate
      size="35"
      v-if="loading"
    ></v-progress-linear>
    <v-card flat rounded="lg" v-else>
      <v-card-text>
        <v-form>
          <v-text-field
            type="date"
            label="Data inicial"
            v-model="filtro.dtini"
          ></v-text-field>
          <v-text-field
            type="date"
            label="Data final"
            v-model="filtro.dtfim"
          ></v-text-field>
          <v-select
            label="Listar"
            :items="tiposListagem"
            no-data-text="Nenhum tipo de listagem disponível"
            item-text="desc"
            item-value="cod"
            v-model="filtro.tipoListagemSelec"
          ></v-select>
          <v-checkbox
            label="Listar remessas"
            v-model="filtro.remessa"
          ></v-checkbox>
          <v-btn
            block
            color="info"
            :loading="gerandoRelat"
            rounded
            depressed
            @click="gerarRelatorio()"
            >Gerar relatório</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import moment from "moment";
import { mapState } from "vuex";
//import { getUrlRelatorio } from "@/global";

export default {
  components: {
    TelaComponent,
  },
  computed: {
    ...mapState("pedidos", ["config", "status"]),
    ...mapState("usuario", ["usuarioLogado"]),
  },
  data: () => ({
    filtro: {
      dtini: moment().subtract(30, "d").format("YYYY-MM-DD"),
      dtfim: moment().format("YYYY-MM-DD"),
      tipoListagemSelec: 1,
      remessa: false,
    },
    tiposListagem: [
      { cod: 1, desc: "Geral" },
      { cod: 2, desc: "Por Município(Detalhado)" },
      { cod: 3, desc: "Por Município(Resumo)" },
    ],
    loading: false,
  }),
  methods: {
    gerarRelatorio() {
      window.open(
        `${
          process.env.VUE_APP_BASE_URL
        }/nutricao-animal/relatorios/vendas?token=${
          this.usuarioLogado.token
        }&dtini=${moment(this.filtro.dtini).format(
          "DD-MM-YYYY"
        )}&dtfim=${moment(this.filtro.dtfim).format(
          "DD-MM-YYYY"
        )}&tiporelat=${this.filtro.tipoListagemSelec}&remessa=${this.filtro.remessa}`,
        "_blank"
      );
    },
  },
};
</script>

<style>
</style>